import { Button, ButtonGroup, HStack, Text } from '@frontend/components';

import type { GeometricAnnotationActions } from './GeometricActionsDataContext';

export const GeometricActionsSet = ({
  geometricActions,
}: {
  geometricActions: GeometricAnnotationActions;
}) => {
  const equalDimensions = geometricActions.getEqualDimensions();

  return (
    <HStack
      spacing={1.5}
      px={1.5}
      py={1}
      align="center"
      borderTop="1px solid"
      borderColor="separator.divider"
    >
      <Text size="sm">Set as</Text>
      <ButtonGroup isAttached size="sm" spacing="-1px">
        <Button
          color={equalDimensions.includes('x') ? undefined : 'geometry.x'}
          onClick={() => geometricActions.setSizeX.fn()}
          variant={equalDimensions.includes('x') ? 'primary' : 'secondary'}
          isLoading={geometricActions.setSizeX.isLoading}
          isDisabled={
            geometricActions.setSizeY.isLoading ||
            geometricActions.setSizeZ.isLoading
          }
        >
          X
        </Button>
        <Button
          color={equalDimensions.includes('y') ? undefined : 'geometry.y'}
          onClick={() => geometricActions.setSizeY.fn()}
          variant={equalDimensions.includes('y') ? 'primary' : 'secondary'}
          isLoading={geometricActions.setSizeY.isLoading}
          isDisabled={
            geometricActions.setSizeX.isLoading ||
            geometricActions.setSizeZ.isLoading
          }
        >
          Y
        </Button>
        <Button
          color={equalDimensions.includes('z') ? undefined : 'geometry.z'}
          onClick={() => geometricActions.setSizeZ.fn()}
          variant={equalDimensions.includes('z') ? 'primary' : 'secondary'}
          isLoading={geometricActions.setSizeZ.isLoading}
          isDisabled={
            geometricActions.setSizeX.isLoading ||
            geometricActions.setSizeY.isLoading
          }
        >
          Z
        </Button>
      </ButtonGroup>
    </HStack>
  );
};
